<script lang="ts" setup>
import { IonPage, IonContent, IonButton } from "@ionic/vue";
import { useFabriqStore } from "@/store/fabriq";
import { useI18n } from "@/composables/useI18n";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import LoadingDiv from "@/components/ui/LoadingDiv.vue";
import AppVersion from "@/components/ui/AppVersion.vue";
import DownloadLogsButton from "@/components/tools/DownloadLogsButton.vue";
import { watch } from "vue";

const fabriqStore = useFabriqStore();
const router = useRouter();

const {
  initializationState,
  loading,
  connected,
  version,
  url,
  intercomEnabled,
} = storeToRefs(fabriqStore);

const { t } = useI18n();

const redirectToQRCode = () => {
  router.push({ name: "ApplicationConfigurationQRCode" });
};

fabriqStore.setInitializationState({ type: "done" });

watch(
  url,
  () => {
    if (!url.value) return;
    if (!connected.value) {
      router.push({ name: "Login" });
    }
  },
  { immediate: true }
);
</script>
<template>
  <ion-page>
    <ion-content :fullscreen="true" class="normal">
      <div
        class="login-block"
        v-if="initializationState.type === 'done' && !loading && !connected"
      >
        <div class="fabriq-logo"></div>
        <div class="page-title">{{ t("common.applicationConfiguration") }}</div>
        <ion-button
          class="configure-with-qrcode-btn"
          color="secondary"
          expand="block"
          mode="ios"
          @click="redirectToQRCode"
        >
          {{ t("common.scanApplicationConfiguration") }}
        </ion-button>
        <div class="or-subdomain-div">
          <ion-button
            class="configure-with-subdomain-btn"
            fill="clear"
            size="small"
            mode="ios"
            color="secondary"
            @click="router.push({ name: 'ApplicationConfigurationSubdomain' })"
          >
            {{ t("common.or") }}
            {{ t("common.subdomainTitle").toLocaleLowerCase() }}
          </ion-button>
        </div>
      </div>
      <loading-div v-else />
      <app-version :version="version" position="absolute" />
    </ion-content>
    <download-logs-button />
    <div
      v-if="intercomEnabled"
      class="get-support-button"
      @click="fabriqStore.openIntercomChat"
    >
      {{ t("common.getSupportLite") }}
    </div>
  </ion-page>
</template>

<style scoped>
.login-block {
  position: relative;
  margin: auto;
  margin-top: 5rem;
  width: calc(100% - 84px);
  text-align: center;
}

.fabriq-logo {
  margin-bottom: calc(var(--ion-padding) * 2);
}

ion-button {
  font-size: var(--font-size-m);
  height: 2.25rem;
}

ion-button::part(native) {
  border-radius: 5px;
}
.page-title {
  font-size: var(--font-size-l);
  margin-top: calc(var(--ion-padding) * 1);
  scale: 1.2;
}

.or-subdomain-div {
  text-align: left;
}

.configure-with-subdomain-btn {
  margin-left: -10px;
}

.configure-with-qrcode-btn {
  margin-top: calc(var(--ion-padding) * 6);
}
</style>
